module.exports = __webpack_public_path__ + "static/img/adv2.15f62665.jpg";